import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import {SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {
    SEARCH_MODEL
} from "../../../../../components/table/Model/TableModel";
import TableFunction from "../../../../../components/table/TableFunction";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomImageTable from "../../../../../components/CustomImageTable";
import {
    IconAvatarTable
} from "../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES} from "../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ManageUsersModalApp = ({ userClassificationSelected }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [results, setResults] = useState([]);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const tableId = "tbl_muma_visitor"; // Set the table ID for identification
    const searchId = 'txt_muma_search_visitor';
    const [selectedList, setSelectedList] = useState([]);

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={false}  classes="first_head">{t('visitor_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('telephone')}</CustomTh>
        ];
    };

    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={false} classes={"first-column"}>
                        <CustomImageTable image={IconAvatarTable} containerClass={"d-flex align-items-center"} text={item?.visitorFullName}/>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.visitorEmail}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.visitorPhoneNumber || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                </>
            );
        });

        return {
            body: body, // Return the generated table rows
            data: results?.content // Return the data associated with the rows
        };
    };

    /**
     * Fetches user data using SimpleSearch API.
     *
     * Flow:
     * - Builds request body using SEARCH_MODEL
     * - Uses current pagination and search filter
     * - Filters by classification model and event id
     * - Stores results in local state
     *
     * Side effects:
     * - Updates results state
     *
     * @function getData
     */
    const getData = (page, {searchElement}) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: userClassificationSelected?.model, modelId:id });

        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data },
                 },
             }) => {
                setResults(data);
            },
        );
    };

    const {
        t,
        thead,
        tbody,
        pagination,
        rowsPerPage
    } = TableFunction({
        data: results,
        selectedList,
        setSelectedList,
        getTbody: getTbody,
        getThead: getThead,
        view:VIEW_TYPE.GRID.name,
        labelRowsPerPage:'users_per_page',
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
    });

    // Return the necessary variables and functions for use in other parts of the app
    return {
        t, // Translation function
        pagination,
        setResults,
        rowsPerPage,
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSimpleSearch,
        setSearch,
        tableId,
        searchId,
        thead,
        tbody,
        selectedList,
        getData
    };
}

export default ManageUsersModalApp; // Export the component to be used in other parts of the app
